import React from "react";
import "./otherProductSlider.component.sass";
import Slider from "react-slick";
import { connect } from "react-redux";
import { SetProduct } from "../../redux/site/site.actions";
import { createStructuredSelector } from "reselect";
import {
	selectProducts,
	selectSelectedProduct,
	selectAccessories,
} from "../../redux/site/site.selector";
import { Setting } from "../../setting";

const OtherProductSliderComponent = ({
	SelectProduct,
	product,
	Products = [],
	Accessories = [],
}) => {
	const settingsH = {
		dots: false,
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		rtl: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 865,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};
	const HandleSelect = (item) => {
		SelectProduct(item);
		window.scrollTo({
			top: 500,
			behavior: "smooth",
		});
	};

	const HandleExist = (item) => {
		switch (parseInt(item.exist)) {
			case 0:
				return "فروش و نصب در نمایندگی ها";
			case 1:
				return "مشاهده مشخصات و سفارش محصول";
			case 2:
				return "بزودی";
			default:
				return null;
		}
		// switch (parseInt(item.exist)) {
		// 	case 0:
		// 		return "فروش و نصب در نمایندگی ها";
		// 	case 1:
		// 		return item.inner_car_price ? `${item.inner_car_price} تومان` : "بزودی";
		// 	case 2:
		// 		return "بزودی";
		// 	default:
		// 		return null;
		// }
	};

	return (
		<div className="other-product-slider">
			{Products && Products.length ? (
				<>
					<div className="one-ul">
						<ul>
							<li>
								<span>محصولات دیگر</span>
							</li>
						</ul>
					</div>
					<Slider {...settingsH}>
						{Products?.filter((x) => x.id !== product.id)?.map((item) => (
							<div
								key={item.id}
								className="other-panel"
							>
								<div
									className="in-mid"
									onClick={() => HandleSelect(item)}
								>
									<img
										className="other-image"
										src={`${Setting.apiUrl}${item.image}`}
										height="190"
									/>
									<div className="other-panel2">
										<h6>
											<strong>{item.name}</strong>
										</h6>
										<p className="other-p">{HandleExist(item)}</p>
									</div>
								</div>
							</div>
						))}
					</Slider>
				</>
			) : (
				""
			)}

			{Accessories && Accessories.length ? (
				<>
					<div className="one-ul">
						<ul>
							<li>
								<span>لوازم جانبی</span>
							</li>
						</ul>
					</div>
					<Slider {...settingsH}>
						{Accessories?.filter((x) => x.id !== product.id)?.map((item) => (
							<div
								key={item.id}
								className="other-panel"
							>
								<div
									className="in-mid"
									onClick={() => HandleSelect(item)}
								>
									<img
										className="other-image"
										src={`${Setting.apiUrl}${item.image}`}
										height="190"
									/>
									<div className="other-panel2">
										<h6>
											<strong>{item.name}</strong>
										</h6>
										<p className="other-p">{HandleExist(item)}</p>
									</div>
								</div>
							</div>
						))}
					</Slider>
				</>
			) : (
				""
			)}
		</div>
	);
};
const mapStateToProps = createStructuredSelector({
	product: selectSelectedProduct,
	Products: selectProducts,
	Accessories: selectAccessories,
});
const mapDispatchToProps = (dispatch) => ({
	SelectProduct: (product) => dispatch(SetProduct(product)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OtherProductSliderComponent);
